import { MenuList, MenuItem, ListItemText, ListItemIcon } from '@mui/material';
import ROUTE from '../../utils/router'
import { Link as RouterLink, useLocation } from 'react-router-dom'

const SubMenu = ({ isMobile, onNavigate }) => {
    const { pathname } = useLocation()
    const mainRoutes = ROUTE.find(route => route.componentName === 'PublicLayout')
    const childrenRouters = mainRoutes.children.filter(route => route.menu && route.secondary)

    const handleNavigate = (to) => {
        if (pathname === to && onNavigate) {
            onNavigate()
        }
    }


    return (
        <>
            <MenuList
                sx={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    flexDirection: 'column',
                
                    p: isMobile ? 2 : 0,
                }}
            >
                {childrenRouters.map(route => {
                    const to = route.index ? mainRoutes.path : `/${route.path}`

                    return (
                        <MenuItem
                            key={`main_menu_${route.path}`}
                            component={RouterLink}
                            to={to}
                            onClick={() => handleNavigate(to)}
                            sx={{
                                borderRadius: 1,
                                width: '100%',
                                backgroundColor: pathname === to ? 'primary.main' : 'transparent',
                                color: pathname === to ? 'primary.contrastText' : 'text.primary',
                                '&:hover': {
                                    backgroundColor: pathname === to ? 'primary.dark' : 'action.hover',
                                },
                            }}
                        >

                            <ListItemText
                                primary={route.title}
                                primaryTypographyProps={{
                                    fontSize: 12, // или '0.875rem'
                                    fontWeight: 500,
                                }}
                            />
                        </MenuItem>

                    )
                })}
            </MenuList>
        </>
    );
};

export default SubMenu;